import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/tailwind.css';
import { Provider } from 'react-redux';
import store from "./redux/store";

<link rel="icon" href="/Images/favicon.ico" />

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
